const serialize = function (obj, str) {
  for (let p in obj) {
    if (typeof obj[p] === 'object') {
      serialize(obj[p], str)
    } else {
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
      }
    }
  }
}

const serializeObject = function (obj) {
  let str = []
  serialize(obj, str)
  return str.join('&')
}

export default serializeObject
